// Combina clases condicionalmente, sin dependencias externas.
// Filtra valores falsos y colapsa los espacios en blanco.
export type ClassValue = string | number | null | false | undefined;

export function cn(...inputs: ClassValue[]): string {
  return inputs.filter(Boolean).join(' ');
}

export default cn;
